import { BodySemi } from 'components/Text';
import { Card, CardContent } from '@/ui/design-system/components';
import { MetricStats } from 'components/HealthStats';
import Stack from 'components/Stack';
import { useEntityPageContext } from './EntityContext';

/**
 * The card the time-series chart sits in: a labelled header with the download
 * button, the chart, and the metric stats under it.
 *
 * `refOnWrapper` is a DOM fact, not a preference: the download button
 * screenshots whatever the ref points at, so Google and pop-index need it on a
 * wrapping div rather than on the chart.
 */
const EntityChartCard = ({
    label,
    labelExtra = null,
    download,
    metricList,
    healthStats,
    refOnWrapper = false,
    children,
}) => {
    const { isLoading, timeSeriesRef } = useEntityPageContext();

    return (
        <Card>
            <CardContent className="p-4 flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    {labelExtra ? (
                        <Stack $direction="row">
                            <BodySemi as="span">{label}</BodySemi>
                            {labelExtra}
                        </Stack>
                    ) : (
                        <BodySemi as="span">{label}</BodySemi>
                    )}
                    {download}
                </div>
                {refOnWrapper ? (
                    <div ref={timeSeriesRef}>{children}</div>
                ) : (
                    children
                )}
                <MetricStats
                    metricList={metricList}
                    healthStats={healthStats}
                    isLoading={isLoading}
                />
            </CardContent>
        </Card>
    );
};

export default EntityChartCard;
